export const recommendedProductMapper = (
  stockData,
  summariesData,
  variants,
) => {
  const { productId, isInStock, productPrice, isRestockingSoon } = stockData;

  const {
    name,
    brandId,
    brandName,
    images,
    sizeGuide,
    isNoSize,
    isOneSize,
    isAvailable,
    productCode,
    colour,
    shippingRestriction,
    isHazmat,
    earlyAccess,
    pdpUrl,
  } = summariesData;

  return {
    id: productId,
    name,
    brandId,
    brandName,
    images,
    sizeGuide,
    isNoSize,
    isOneSize,
    isAvailable,
    isInStock,
    productCode,
    colour,
    shippingRestriction,
    variants,
    isHazmat,
    earlyAccess,
    price: {
      current: productPrice?.current,
      previous: productPrice?.previous,
      rrp: productPrice?.rrp,
    },
    restockingSoonDetails: { isRestockingSoon },
    pdpUrl,
  };
};
